import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import "../tpsSideBar.css";

const SideNav = () => {
  const [isSidebarOpen, setIsSidebarOpen] = useState(false);
  const [mastersOpen, setMastersOpen] = useState(false);
  const [reportsOpen, setReportsOpen] = useState(false);
  const userName = localStorage.getItem('HostName') || 'Guest';

  useEffect(() => {
    const handleResize = () => setIsSidebarOpen(window.innerWidth >= 990);
    handleResize();
    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  const handleLogout = () => {
    localStorage.removeItem('token');
    localStorage.removeItem('HostName');
    localStorage.removeItem('HostID');
    window.location.href = '/cl';
  };

  return (
    <>
      <button
        className="toggle-btn rounded"
        onClick={() => setIsSidebarOpen(!isSidebarOpen)}
        aria-label="Toggle sidebar"
      >
        ≡
      </button>

      <aside className={`off-canvas-menu  ${isSidebarOpen ? 'open' : ''}`}>
        <div className="brand ml-2">TPS HOST</div>
        <div className="user-panel border border-white p-2 rounded">Welcome: {userName}</div>

        <nav>
          <ul>
            <li>
              <Link to="/host/dashboard" onClick={() => window.innerWidth < 990 && setIsSidebarOpen(false)}>
                Dashboard
              </Link>
            </li>

            <li>
              <button onClick={() => setMastersOpen(!mastersOpen)} className="nav-toggle-btn">
                Masters {mastersOpen ? '▲' : '▼'}
              </button>
              {mastersOpen && (
                <ul>
                  <li><Link to="/host/verify-author" onClick={() => window.innerWidth < 990 && setIsSidebarOpen(false)}>Validate Author</Link></li>
                  <li><Link to="/host/verify-reviewer" onClick={() => window.innerWidth < 990 && setIsSidebarOpen(false)}>Validate Reviewer</Link></li>
                  <li><Link to="/host/submission-assignment" onClick={() => window.innerWidth < 990 && setIsSidebarOpen(false)}>Assign Submission</Link></li>
                  <li><Link to="/host/review-replies-list" onClick={() => window.innerWidth < 990 && setIsSidebarOpen(false)}>Review Replies</Link></li>
                  <li><Link to="/host/reviewer-decision-matrix" onClick={() => window.innerWidth < 990 && setIsSidebarOpen(false)}>Comment Matrix</Link></li>
                </ul>
              )}
            </li>

            <li>
              <button onClick={() => setReportsOpen(!reportsOpen)} className="nav-toggle-btn">
                Reports {reportsOpen ? '▲' : '▼'}
              </button>
              {reportsOpen && (
                <ul>
                  <li><Link to="/host/authors-list" onClick={() => window.innerWidth < 990 && setIsSidebarOpen(false)}>Author Registered</Link></li>
                  <li><Link to="/host/reviewer-list" onClick={() => window.innerWidth < 990 && setIsSidebarOpen(false)}>Reviewer Registered</Link></li>
                  <li><Link to="/host/submission-list" onClick={() => window.innerWidth < 990 && setIsSidebarOpen(false)}>Submissions</Link></li>
                </ul>
              )}
            </li>

            <li>
              <button className="logout-btn" onClick={handleLogout}>
                Logout
              </button>
            </li>
          </ul>
        </nav>
      </aside>

      <div
        className={`overlay ${isSidebarOpen ? 'visible' : ''}`}
        onClick={() => setIsSidebarOpen(false)}
        aria-hidden={!isSidebarOpen}
      />
    </>
  );
};

export default SideNav;
